import type { FeedbackPlatform, FeedbackPostType } from './types';

const TYPE_LABELS: Record<FeedbackPostType, string> = {
  hook: 'Hook Feedback',
  caption: 'Caption Feedback',
  content_idea: 'Content Idea Feedback',
  profile: 'Profile Feedback',
  general: 'General Feedback',
};

const PLATFORM_LABELS: Record<FeedbackPlatform, string> = {
  tiktok: 'TikTok',
  instagram: 'Instagram',
  youtube: 'YouTube',
  other: 'Other',
};

export function feedbackTypeLabel(t: FeedbackPostType): string {
  return TYPE_LABELS[t] ?? t;
}

export function feedbackPlatformLabel(p: FeedbackPlatform): string {
  return PLATFORM_LABELS[p] ?? p;
}
